import api from "./api";

// Facility booking blocks (system-user / RBAC — gated by "view_facility_blocks",
// "create_facility_blocks" and "delete_facility_blocks" on the backend). A
// block reserves a facility (or one specific facility slot) against bookings
// for a date range, optionally narrowed to a time range within each day.
// Unlike Clubs/Bookings/Payments/Fees/Attendance, this module has full
// list/create/delete backend support (no update route — delete and recreate).

// GET /api/facility-blocks — optional { facility_id, date, block_status }
// filters; block_status defaults to "Active" server-side if omitted (pass
// "" or "all" to see every status: Active/Pending/Rejected/Removed —
// Pending/Rejected only ever come from the request flow in
// facilityBlockRequestService.js, direct creates go straight to Active).
// Returns a plain array of blocks: {id, facility_id, facility_name,
// facility_slot_id, slot_code, start_date, end_date, start_time, end_time,
// reason, block_status_id, block_status, created_by, created_by_name,
// created_at, updated_at, pending_block_request, pending_unblock_request
// (bools — is a request already in flight for this block), is_past,
// can_delete (bool — Active and not yet past; gates the direct-unblock
// "Remove" action)}.
export const listFacilityBlocks = (params = {}) =>
  api.get("/api/facility-blocks", { params }).then((r) => (Array.isArray(r.data) ? r.data : []));

// POST /api/facility-blocks  { facility_id, facility_slot_id?, start_date,
// end_date, start_time?, end_time?, reason }. reason is required (not
// optional — FacilityBlockController::store validates it as
// ['required', 'string', 'max:1000']). facility_slot_id must belong to
// facility_id if given (omit to block the whole facility). start_time/end_time
// must be given together ("H:i") or both omitted (omit to block full days).
// The backend 422s (with `booking_ids`) if the period already has pending or
// confirmed bookings. Response is unwrapped from the backend's [[ {...} ]]
// nesting so callers get a plain object; also carries `pending_unblock_request`
// (bool) — true when an Instructor's unblock request is already Pending for
// this block, which the UI uses to disable duplicate "Request Unblock" clicks.
export const createFacilityBlock = (payload) =>
  api.post("/api/facility-blocks", payload).then((r) => (Array.isArray(r.data) ? r.data[0] : r.data));

// DELETE /api/facility-blocks/{id}  { reason }. reason is required —
// FacilityBlockController::destroy validates it as
// ['required', 'string', 'max:1000'] and 422s without one ("A reason is
// required to unblock."). Axios needs the body passed under `data` for a
// DELETE request. Admin/Director only (gated by "delete_facility_blocks");
// an Instructor without that permission must go through
// facilityUnblockRequestService.js's submit -> approve flow instead. If a
// Director/Admin unblocks directly while an unblock request is still
// Pending for this block, the backend auto-closes that request as Approved
// with a note explaining the direct unblock, rather than leaving it
// orphaned.
export const deleteFacilityBlock = (id, reason) =>
  api.delete(`/api/facility-blocks/${id}`, { data: { reason } }).then((r) => (Array.isArray(r.data) ? r.data[0] : r.data));
